export enum NotificationType {
    INFO = 'neutral',
    SUCCESS = 'success',
    WARNING = 'warning',
    ERROR = 'error'
}
